module.exports = __webpack_public_path__ + "img/img3_6.4eebf83f.jpeg";